// extracted by mini-css-extract-plugin
export default {"roomInfo":"index_roomInfo__iajf-","sperature":"index_sperature__qjj7T","record_wrap":"index_record_wrap__oBNRA","record_wrapIcon":"index_record_wrapIcon__36ArF"};